module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/ribbon/ribbon-style-2/ribbon-style-2.component.scss
// module id = ./src/app/features/ribbon/ribbon-style-2/ribbon-style-2.component.scss
// module chunks = main